
import React, { ReactNode } from "react";
import { useAdminContextValue } from "./useAdminContextValue";
import { AdminProvider as AdminContextProvider } from "./AdminContextProvider";
import { useAdmin } from "./AdminContextProvider";

interface AdminProviderProps {
  children: ReactNode;
}

export const AdminProvider = ({ children }: AdminProviderProps) => {
  const adminContextValue = useAdminContextValue();

  return (
    <AdminContextProvider value={adminContextValue}>
      {children}
    </AdminContextProvider>
  );
};

// Re-export the useAdmin hook for convenience
export { useAdmin };
